/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Niket Jain",
  title: "I'm Niket",
  subTitle: emoji(
    "Passionate Mobile App Developer |  3+ years of crafting innovative solutions with Android, Flutter, and Kotlin Multiplatform."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1yAtbgFW1xt2NFZER_bco7FS_lr3DvFxp/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/nikeight",
  linkedin: "https://linkedin.com/in/nikeight",
  gmail: "niket8jain@gmail.com",
  // gitlab: "https://github.com/nikeight",
  // facebook: "https://www.facebook.com/saad.pasta7",
  medium: "https://medium.com/@nikeight",
  stackoverflow: "https://stackoverflow.com/users/14174657/nikeight",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "Crafting innovative Mobile experiences, with keen intereset in anything related to mobile.",
  skills: [
    emoji(
      "⚡ Android Development: \n Proficient in Java and Kotlin, with expertise in creating scalable and high-performance Android applications."),
    emoji("⚡ Flutter Development: \n Skilled In building cross-platform mobile apps using Flutter, leveraging its rapid development capabilities and rich UI components."),
    emoji(
      "⚡ Kotlin Multiplatform: \n Experienced in developing shared codebases for Android and iOS using Kotlin Multiplatform, promoting code reusability and efficiency."),
    emoji(
      "⚡ Backend Fundamentals: \n Basic knowledge of backend technologies and principles, including RESTful APIs and database interactions.")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Kotlin",
      fontAwesomeClassname: "fab fa-android"
    },
    {
      skillName: "Android",
      fontAwesomeClassname: "fab fa-android"
    },
    {
      skillName: "Flutter",
      fontAwesomeClassname: "fab fa-android"
    },
    {
      skillName: "KMP",
      fontAwesomeClassname: "fab fa-android"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Chhattisgarh Swami Vivekanand Technical University",
      logo: require("./assets/images/csvtu.png"),
      subHeader: "Bachelor of Engineering",
      duration: "September 2017 - April 2021",
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Android Engineer",
      company: "Mutual Mobile",
      companylogo: require("./assets/images/mm_logo.jpg"),
      date: "September 2021 – July 2024",
      desc: "Promoted to Android Engineer, based on the last year perfromance.",
      descBullets: [
        "Working together with cross-functional platform teams to create Flutter applications and meet development objectives collaboratively",
        "Fulfilling the role of a code reviewer for select Android projects to ensure the upkeep of code quality.",
        "Worked on Test Coverage and performance",
        "Worked on the setup of GitHub action flows for projects, optimizing workflow efficiency.",
        "Collaborated within an internal team to develop a foundational project structure plugin, streamlining project initiation processes.",
        "Successfully contributed to 3 intricate projects, demonstrating adaptability.",
        "Mentoring junior developers and providing guidance on technical matters"
      ]
    },
    {
      role: "Android Developer Intern",
      company: "Kylo Apps",
      companylogo: require("./assets/images/kylo_apps_logo.jpeg"),
      date: "July 2021 – September 2021",
      descBullets:[
        "Developing apps are based on a REST API and Oauth2. Work on the client and server-side of the project using the latest technical solutions for each platform using design patterns like MVP and MVVM.",
        "Delivering Pixel perfect UI",
        "Ensuring the app's functionality and performance through manual or automated testing"
      ]
    },
    {
      role: "Android Developer Intern",
      company: "Code Vector Apps",
      companylogo: require("./assets/images/cv_logo.png"),
      date: "Nov 2020 – March 2021",
      descBullets:[
        "Developing apps are based on a REST API and Oauth2. Work on the client and server-side of the project using the latest technical solutions for each platform using design patterns like MVP and MVVM.",
        "Delivering Pixel perfect UI",
        "Worked with ML Models to develop the Kiosk Mode feature in the Attendance App",
        "Assisting with project planning and tracking"
      ]
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "My contribution to Startup and Companies I joined as a developer.",
  projects: [
    {
      image: require("./assets/images/dealerware_logo.avif"),
      projectName: "Dealerware by Silver Cars",
      projectDesc: "Fleet Management System, made to manage the Audi rental cars.",
      footerLink: [
        {
          name: "Play Store link",
          url: "https://play.google.com/store/apps/details?id=com.silvercar.dealerware&hl=en_IN"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/ember_logo.png"),
      projectName: "Ember Tech",
      projectDesc: "Bluetooth Hardware mug management system.",
      footerLink: [
        {
          name: "Play Store link",
          url: "https://play.google.com/store/apps/details?id=com.embertech&pcampaignid=web_share"
        }
      ]
    },
    {
      image: require("./assets/images/treat_logo_xpress.png"),
      projectName: "Xpress Treat",
      projectDesc: "Health and Wellness App",
      footerLink: [
        {
          name: "Website",
          url: "https://www.xpresspa.com/home/"
        }
      ]
    },
    {
      image: require("./assets/images/ercot_logo.webp"),
      projectName: "Ercot Energy Saver",
      projectDesc: "Track, Maintain, get updates from your city power plants.",
      footerLink: [
        {
          name: "Play Store",
          url: "https://play.google.com/store/apps/details?id=com.ercot.ercotMobileOne&hl=en_IN"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Speaker of the Year 2023",
      subtitle:
        "Being recognized in the organisation for sharing my new learnings with the team and the community",
      image: require("./assets/images/gd_logo.jpg"),
      imageAlt: "gd_award.jpg",
      footerLink: [
        {
          name: "Award Letter",
          url: "https://www.linkedin.com/posts/nikeight_thrilled-to-have-received-the-speaker-of-activity-7150061636093915136-p2Fs?utm_source=share&utm_medium=member_desktop"
        },
        {
          name: "Gift",
          url: "https://www.linkedin.com/posts/nikeight_thrilled-to-have-received-the-speaker-of-activity-7150061636093915136-p2Fs?utm_source=share&utm_medium=member_desktop"
        },
        {
          name: "Achievements",
          url: "https://www.linkedin.com/posts/nikeight_thrilled-to-have-received-the-speaker-of-activity-7150061636093915136-p2Fs?utm_source=share&utm_medium=member_desktop"
        }
      ]
    },
    {
      title: "Master Coroutines and Flows",
      subtitle:
        "Completed the Udemy course on the Kotlin Coroutines and Flows. ",
      image: require("./assets/images/master_coroutine_flow_certification_img.jpg"),
      imageAlt: "udemy_course_img.jpg",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.udemy.com/course/coroutines-on-android"
        }
      ]
    },

    {
      title: "Hackathon Mentor Award",
      subtitle: "Inspired and mentor the participants to push and deliver their best.",
      image: require("./assets/images/opin_co_hacks.png"),
      imageAlt: "hackthon_hts.jpg",
      footerLink: [
        {
          name: "Award",
          url: "https://x.com/nikeight_/status/1721907893077950765"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "I keep exploring new things and try to share my result and experience with everyone.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://medium.com",
      title: "Make your Android app adaptive and responsive",
      description:
        "With 2024 year Google I/O Jetpack compose team have released new easy to use API to make your app responsive."
    },
    {
      url: "https://medium.com",
      title: "Add Android Widgets easily using the new Glance Framework",
      description:
        "Android is all about customization, make sure you provide enough options to your users."
    },
    {
      url: "https://medium.com",
      title: "Change complete app theme in Flutter without ThemeData",
      description:
        "Lets makes simple things simple with this nice clean trick."
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "Tech Talks",
  subtitle: emoji(
    "Whenever I see something amazing and inspiring, I love to share the information with the medium of Tech Talks at community events."
  ),

  talks: [
    {
      title: "Understanding Flutter Animation APIs",
      subtitle: "This talk demonstrate all the techniques to master the animations in Flutter.",
      slides_url: "https://github.com/nikeight/flutter_learning_playground/tree/main/Animations",
      event_url: "https://x.com/GDGRaipur/status/1733142390536315264"
    },
    {
      title: "Whats new in Flutter Google I/O 2022",
      subtitle: "We will deep dive into whats new in Flutter",
      slides_url: "https://docs.google.com/presentation/d/1rJzj1e99GcetBPGD96Hj3e7p5qYctw3pUzTaGxij-6k/edit?usp=sharing&resourcekey=0-SjS-v3YbABODfPY8MfkGyw",
      event_url: "https://x.com/gdgbhilai/status/1666444942342774789"
    },
    {
      title: "Android Widgets using Glance Framework",
      subtitle: "Add more features to your Android app using the Glance Framework",
      slides_url: "https://docs.google.com/presentation/d/1bVeAE8UHzfxwrwarxl7aW-wL3LuI0gH3xdW1gOXZ3fU/edit?usp=sharing",
      event_url: "https://x.com/GDGRaipur/status/1604452395554988032"
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I shared my Experience, mistakes and advice to young developers. ",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://www.youtube.com/watch?v=J8kd-M6upQo&t=10s"
  ],
  display: true // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "",
  email_address: "niket8jain@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "nikeight_", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
